import { S25Util } from "../../../../util/s25-util";
import { EventService, Etags } from "../../../../services/event.service";
import { S25ProfileUtil } from "../../utils/s25.profile.util";
import { ReservationService } from "../../../../services/reservation.service";
import { WsDataI, EventMircotI, EventDataMicroI, WSReservations } from "../../EventMicroI";
import { AvailLocationItems, AvailResourceItems } from "../../../s25-object-search/s25.object.search.util";
import {
    S25Reservation,
    S25ObjectReservation,
    S25RsReservation,
    S25RmReservation,
    ObjectType,
} from "../../ReservationI";
import { S25Event } from "../../EventMicroI";
import { S25Profile, AdditionalTime, Ids, RecordType } from "../../ProfileI";
import { EventSummaryService } from "../../../s25-swarm-schedule/s25.event.summary.service";
import { BOARD_CONST } from "../../../s25-swarm-schedule/s25.board.const";
import { Proto } from "../../../../pojo/Proto";
import DowNumber = Proto.DowNumber;

declare global {
    interface Window {
        angBridge: any;
    }
}
export class EventOccUtil {
    public static async copyOcc(occ: S25Reservation) {
        let newRsrvId: any = await ReservationService.generateReservationIds(1);
        let copyOcc: S25Reservation[] = [];
        copyOcc.push({
            itemId: newRsrvId.idSet[0].rsrvId,
            locations: occ.locations,
            resources: occ.resources,
            comments: occ.comments,
            profileId: occ.profileId,
            profileName: occ.profileName,
            state: 1,
            eventStart: occ.eventStart,
            eventEnd: occ.eventEnd,
        } as S25Reservation);

        if (occ.postEventEnd) copyOcc[0].postEventEnd = occ.postEventEnd;
        if (occ.preEventStart) copyOcc[0].preEventStart = occ.preEventStart;
        if (occ.setupStart) copyOcc[0].setupStart = occ.setupStart;
        if (occ.takeDownEnd) copyOcc[0].takeDownEnd = occ.takeDownEnd;
        return copyOcc[0];
    }

    //eventEnd: S25Util.date.parse(S25Util.date.copyTime(new Date(), occ.eventEnd)),
    //     public static changeActive(e: any, occ: S25Reservation) {
    //         console.log({ e: e });
    //         return occ;
    //     }

    //     public static delOcc(occ: S25Reservation) {
    //         return occ;
    //     }

    //     public static saveOcc(occ: S25Reservation) {
    //         return occ;
    //     }

    //delete and copy occurrance, date/tiem changed apply  to this function
    public static normalizeEventWSData(
        event: EventMircotI,
        occ: S25Reservation,
        isCopy?: boolean,
        isDelete?: boolean,
        isDateTimeChanged?: boolean,
        keepRepeatPattern?: boolean,
    ) {
        let locations = S25ProfileUtil.normalizeObjectsData(occ.locations, "location");
        let resources = S25ProfileUtil.normalizeObjectsData(occ.resources, "resource");

        let findProfile = event.profile.find((p: S25Profile) => {
            return p?.itemId === occ.profileId;
        });

        //if not copy and delete
        if (!isCopy && !isDelete) {
            findProfile.reservations = findProfile.reservations.map((rsrv: S25Reservation) => {
                if (rsrv.itemId === occ.itemId) {
                    return { ...rsrv, ...occ };
                }
                return rsrv;
            });
        }

        if (isDelete) {
            findProfile.reservations = findProfile.reservations.filter((item: S25Reservation) => {
                return item.itemId !== occ.itemId;
            });

            if (findProfile.reservations.length === 1) {
                findProfile.occurrenceDefn.recTypeId = RecordType.SingleDateTime;
                findProfile.occurrenceDefn.profileCode = this.setSingleProfieCode(
                    findProfile.reservations[0].eventStart as Date,
                );
            } else {
                findProfile.occurrenceDefn.recTypeId = RecordType.FreeForm;
            }
        }

        let isSingleOcc =
            findProfile.occurrenceDefn.recTypeId === RecordType.SingleDateTime || findProfile.reservations.length === 1;

        let reservations = S25ProfileUtil.normalizeRsrvWSData(
            findProfile.reservations,
            isSingleOcc ? RecordType.SingleDateTime : RecordType.FreeForm,
        );

        if (isCopy) {
            let generateNewOcc = {
                rsrvId: occ.itemId,
                comments: occ.comments,
                state: occ.state,
                occurrence: S25Util.date.toS25ISODateStr(occ.eventStart),
                rsrvStartDt:
                    S25Util.date.toS25ISODateTimeStr(occ.setupStart) ||
                    S25Util.date.toS25ISODateTimeStr(occ.preEventStart) ||
                    S25Util.date.toS25ISODateTimeStr(occ.eventStart),
                evStartDt: S25Util.date.toS25ISODateTimeStr(occ.eventStart),
                evEndDt: S25Util.date.toS25ISODateTimeStr(occ.eventEnd),
                rsrvEndDt:
                    S25Util.date.toS25ISODateTimeStr(occ.takeDownEnd) ||
                    S25Util.date.toS25ISODateTimeStr(occ.postEventEnd) ||
                    S25Util.date.toS25ISODateTimeStr(occ.eventEnd),
                spaces: locations,
                resources: resources,
            } as WSReservations;

            reservations.push(generateNewOcc); // ads hoc and RecurrenceGrammar payload need exising rsrvs otherwise service got no mpping rsrvs error

            if (!keepRepeatPattern) {
                findProfile.occurrenceDefn.recTypeId = RecordType.FreeForm;
                delete findProfile.occurrenceDefn?.adHocDates;
                if (findProfile?.occurrenceDefn?.profileCode) findProfile.occurrenceDefn.profileCode = "";
            }
        }

        //  this occ to  changes  DateTime, just update this occ
        if (isDateTimeChanged && !(isCopy && keepRepeatPattern)) {
            if (isSingleOcc && !isCopy) {
                // single occ need to update occurrenceDefn
                findProfile.occurrenceDefn.recTypeId = RecordType.SingleDateTime;
                delete findProfile.occurrenceDefn?.adHocDates;
                delete reservations[0]?.rsrvStartDt; // ignored for SINGLE, AD-HOC, RECURRENCE profiles
                delete reservations[0]?.occurrence; // ignored for SINGLE, rsrvEndtDt values for each occurrence date

                findProfile.occurrenceDefn.profileCode = this.setSingleProfieCode(occ.eventStart as Date);
                findProfile.occurrenceDefn.initStartDt = S25Util.date.toS25ISODateTimeStr(occ.eventStart);
                findProfile.occurrenceDefn.initEndDt = S25Util.date.toS25ISODateTimeStr(occ.eventEnd);
            } else {
                findProfile.occurrenceDefn.recTypeId = RecordType.FreeForm;
                findProfile.occurrenceDefn.profileCode = "";
            }

            reservations = reservations.filter((rsrv) => {
                return rsrv.rsrvId === occ.itemId;
            });
        }

        let etags: Etags = { id: event.itemId, etag: event.etag };
        let data: EventDataMicroI = {
            items: [
                {
                    kind: "event",
                    id: event.itemId,
                    name: event.itemName,
                    isActive: event.isActive,
                    dates: {
                        startDate:
                            S25Util.date.toS25ISODateTimeStr(occ.setupStart) ||
                            S25Util.date.toS25ISODateTimeStr(occ.preEventStart) ||
                            S25Util.date.toS25ISODateTimeStr(occ.eventStart),
                        endDate:
                            S25Util.date.toS25ISODateTimeStr(occ.takeDownEnd) ||
                            S25Util.date.toS25ISODateTimeStr(occ.postEventEnd) ||
                            S25Util.date.toS25ISODateTimeStr(occ.eventEnd),
                    },
                    profiles: [
                        {
                            profileId: occ.profileId,
                            name: occ.profileName,
                            occurrenceDefn: findProfile?.occurrenceDefn,
                            reservations: reservations,
                        },
                    ], // profiles
                },
            ], // items
        };
        return [{ eTags: etags, data: data }];
    }

    // All space and resource reservations input with no label (draft,  request  & reserved)
    //// add Object apply to this function
    public static normalizeAddRsrvWSData(
        newItem: AvailLocationItems | AvailResourceItems | null,
        addedItems: any[],
        type: ObjectType,
        requestQty: number,
    ) {
        let results = [];
        if (type === "location") {
            let share = newItem.always_shared === "T";
            if (newItem?.checkedObj?.conflicts) {
                share = newItem?.checkedObj?.conflicts.some((item: AvailLocationItems) => item.conflictShare === true);
            }

            if (newItem !== null) {
                results.push({
                    spaceId: newItem.space_id,
                    spaceName: newItem.space_name,
                    share: share,
                });
            }
        } else {
            if (newItem !== null) {
                results.push({
                    resourceId: newItem.resource_id,
                    resourceName: newItem.resource_name,
                    quantity: requestQty,
                } as S25RsReservation);
            }
        }
        return results;
    }

    // All space and resource reservations input with no label (draft,  request  & reserved)
    // delete Object apply to this function
    public static normalizeDeleteRsrvWSData(
        removeItem: S25RmReservation | S25RsReservation | null | any,
        addItem: AvailLocationItems | AvailResourceItems | null,
        nodeName: string,
        occ: S25Reservation,
        type: ObjectType,
    ) {
        let results: any;
        let locations = S25ProfileUtil.normalizeObjectsData(occ.locations, "location");
        let resources = S25ProfileUtil.normalizeObjectsData(occ.resources, "resource");

        if (type === "location") {
            let dataset = {
                layoutId: removeItem?.layout?.itemId,
                instructions: removeItem.instructions,
                spaceId: removeItem.itemId,
            };
            results = { spaces: locations, remove: { spaces: [{ [nodeName]: [dataset] }] } };
        } else {
            let dataset = {
                instructions: removeItem.instructions,
                resourceId: removeItem.itemId,
            };
            results = { resources: resources, remove: { resources: [{ [nodeName]: [dataset] }] } };
        }
        return results;
    }

    public static getRepetitionText(profileCode: string) {
        const weekdayString = EventSummaryService.getWeekdayText(profileCode, null);
        return EventSummaryService.getRepetitionText(profileCode, null, null, null, weekdayString);
    }

    public static setSingleProfieCode(date: Date) {
        const dow = S25Util.date.parseDropTZ(date).getDay() as DowNumber;
        const profileCode =
            "W1 " +
            BOARD_CONST.dowInt2Abbr[dow] +
            " " +
            S25Util.date.toS25ISODateStr(date).replace(/-/g, "") +
            "T235900";
        return profileCode;
    }
}
